import api from "./../Api";
import { BaseService } from "./../BaseService";

const URL = "articles";

export class ArticlesService extends BaseService {
  async list(params: any, config?: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params, config));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async fetch(id: number | null, params: any): Promise<any> {
    try {
      const data = new FormData();
      id && data.append("id", String(id));

      data.append("is_file", String(params.is_file));
      data.append("is_internal", String(params.is_internal));
      data.append("prompt_filters", params.prompt_filters ?? "");
      data.append("prompt_article", params.prompt_article ?? "");
      data.append("category_id", String(params.category_id));
      params.section_id && data.append("section_id", String(params.section_id));
      params.subsection_id &&
        data.append("subsection_id", String(params.subsection_id));
      data.append("content", params.content);
      data.append("content_ia", params.content_ia);
      data.append("title", params.title);
      params.model_name && data.append("model_name", params.model_name ?? null);
      data.append(
        "related_articles",
        JSON.stringify(params.related_articles ?? [])
      );
      data.append(
        "access_profile_articles",
        JSON.stringify(params.access_profile_articles ?? [])
      );
      data.append(
        "tags",
        JSON.stringify(params.tags ?? [])
      );
      if (params.is_file) {
        params.list_file.forEach((item: any) => {
          if (item.file instanceof File) {
            data.append("list_file", item.file);
          } else if (item.filePath) {
            data.append("list_file", item.filePath);
          }
        });

        data.append("list_prompt", JSON.stringify(params.list_prompt ?? []));
      }

      return this.handleResponse(
        await api.post(id ? `${URL}/update` : `${URL}/create`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async delete(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listRelated(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/${id}/related`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listByStructure(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/hierarchy`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async vote(articleId: number, vote: boolean): Promise<any> {
    try {
      return this.handleResponse(
        await api.post(`${URL}/${articleId}/vote`, { vote })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async voteStatus(articleId: number): Promise<any> {
    try {
      return this.handleResponse(
        await api.get(`${URL}/${articleId}/vote/status`)
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async mostRead(): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/most-read`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async insertView(articleId: number): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/${articleId}/view`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async sortArticle(params: any): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/sort`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async version(params: any): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/version`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async restoreVersion(params: any): Promise<any> {
    try {
      return this.handleResponse(
        await api.post(`${URL}/version/restore`, params)
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async reactivate(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/reactivate/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async deactivateBulk(ids: number[]): Promise<any> {
    try {
      return this.handleResponse(
        await api.post(`${URL}/deactivate-bulk`, { ids })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async replaceFileBulk(ids: number[], file: File): Promise<any> {
    try {
      const data = new FormData();
      data.append("ids", JSON.stringify(ids));
      data.append("file", file);
      // Endereço da API usado nos links dos anexos (mesmo que o editor usa no upload).
      data.append("base_url", process.env.REACT_APP_BEVIAJUDA_API || "");

      return this.handleResponse(
        await api.post(`${URL}/replace-file-bulk`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
